// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/List.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { List, ListItem, view, css } from '@sail/ui';

const Container = ({
  children
}) => <view.div css={{
  width: css.value('300px'),
  background: 'surface',
  padding: 'medium',
  borderRadius: 'large'
}}>
    {children}
  </view.div>;

const basic = {
  rendered: <Container>
      <List onAction={id => alert(`Pressed row #${id}`)} aria-label="Example of a List">
        <ListItem value="$100.00" id={1}>
          <view.div>Payment #1862</view.div>
          <view.div slot="description">customer@test.com</view.div>
        </ListItem>
        <ListItem value="$63.00" id={2}>
          <view.div>Payment #9273</view.div>
          <view.div slot="description">frank@example.com</view.div>
        </ListItem>
        <ListItem value="$7,471.62" id={3}>
          <view.div>Payment #643</view.div>
          <view.div slot="description">robert@google.com</view.div>
        </ListItem>
        <ListItem value="$871.01" id={4}>
          <view.div>Payment #123</view.div>
          <view.div slot="description">example@gmail.com</view.div>
        </ListItem>
      </List>
    </Container>,
  source: `<List
  onAction={(id: string | number) => alert(\`Pressed row #\${id}\`)}
  aria-label="Example of a List"
>
  <ListItem value="$100.00" id={1}>
    <Box>Payment #1862</Box>
    <Box slot="description">customer@test.com</Box>
  </ListItem>
  <ListItem value="$63.00" id={2}>
    <Box>Payment #9273</Box>
    <Box slot="description">frank@example.com</Box>
  </ListItem>
  <ListItem value="$7,471.62" id={3}>
    <Box>Payment #643</Box>
    <Box slot="description">robert@google.com</Box>
  </ListItem>
  <ListItem value="$871.01" id={4}>
    <Box>Payment #123</Box>
    <Box slot="description">example@gmail.com</Box>
  </ListItem>
</List>`
};
const items = {
  rendered: <Container>
      <List onAction={id => alert(id)} aria-label="Example of a List">
        <ListItem id="apple">
          <view.div>Apple</view.div>
        </ListItem>
        <ListItem id="orange">
          <view.div>Orange</view.div>
        </ListItem>
        <ListItem id="banana">
          <view.div>Banana</view.div>
        </ListItem>
      </List>
    </Container>,
  source: `<List
  onAction={(id: string | number) => alert(id)}
  aria-label="Example of a List"
>
  <ListItem id="apple">
    <Box>Apple</Box>
  </ListItem>
  <ListItem id="orange">
    <Box>Orange</Box>
  </ListItem>
  <ListItem id="banana">
    <Box>Banana</Box>
  </ListItem>
</List>`
};
const descriptions = {
  rendered: <Container>
      <List onAction={id => alert(id)} aria-label="Example of a List">
        <ListItem id={1}>
          <view.div>John Smith</view.div>
          <view.div slot="description">johnsmith@test.com</view.div>
        </ListItem>
        <ListItem id={2}>
          <view.div>Jane Doe</view.div>
          <view.div slot="description">janedoe@test.com</view.div>
        </ListItem>
        <ListItem id={3}>
          <view.div>Mark Foster</view.div>
          <view.div slot="description">markfoster@test.com</view.div>
        </ListItem>
      </List>
    </Container>,
  source: `<List
  onAction={(id: string | number) => alert(id)}
  aria-label="Example of a List"
>
  <ListItem id={1}>
    <Box>John Smith</Box>
    <Box slot="description">johnsmith@test.com</Box>
  </ListItem>
  <ListItem id={2}>
    <Box>Jane Doe</Box>
    <Box slot="description">janedoe@test.com</Box>
  </ListItem>
  <ListItem id={3}>
    <Box>Mark Foster</Box>
    <Box slot="description">markfoster@test.com</Box>
  </ListItem>
</List>`
};
export const ListExamples = {
  basic,
  items,
  descriptions
};
